import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { HasImagePipe } from '../../../pipes';
import { DataViewModule } from 'primeng/dataview';
import { DividerModule } from 'primeng/divider';
import { DialogModule } from 'primeng/dialog';
import { CardModule } from 'primeng/card';
import { NgxAimOverviewRentalsClass } from './ngx-aim-overview-rentals.class';
import { AsyncPipe, CurrencyPipe, DatePipe } from '@angular/common';
import { PublicRoutes } from '../../../enums';
import { CheckboxModule } from 'primeng/checkbox';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'ngx-aim-overview-rentals',
  standalone: true,
  imports: [
    ButtonModule,
    DataViewModule,
    DividerModule,
    DialogModule,
    CardModule,
    AsyncPipe,
    CurrencyPipe,
    DatePipe,
    HasImagePipe,
    CheckboxModule,
    FormsModule,
  ],
  templateUrl: './ngx-aim-overview-rentals.component.html',
  styleUrls: ['./ngx-aim-overview-rentals.component.css'],
})
export class NgxAimOverviewRentalsComponent extends NgxAimOverviewRentalsClass implements OnInit {
  @Input({ required: true })
  override completeUrl: string = PublicRoutes.RENTAL_COMPLETE;

  @Input()
  override userMustClickIAgree = false;

  @Output()
  override showTerms = new EventEmitter<void>();

  ngOnInit() {
    this.init();
  }
}
